import React, {useEffect, useRef} from 'react';
import {Router as ReactRouter, Route, Switch, withRouter} from 'react-router-dom';
import {createBrowserHistory} from 'history';

import {withUser} from './lib/user';
import {pageView} from './lib/google-analytics';
import LabelWatcher from './components/LabelWatcher';
import NotificationWatcher from './components/NotificationWatcher';
import HasManagementRole from "./security/rules/HasManagementRole";
import HasAdminRole from "./security/rules/HasAdminRole";

import HomeScreen from './screens/HomeScreen';
import ReportScreen from './screens/ReportScreen';
import UserScreen from './screens/UserScreen';
import LoginScreen from './screens/LoginScreen';
import ForgotPasswordScreen from './screens/ForgotPasswordScreen';
import ResetPasswordScreen from './screens/ResetPasswordScreen';
import PrivacyPolicyScreen from './screens/PrivacyPolicyScreen';
import SheetScreen from './screens/SheetScreen';
import FormListScreen from './screens/FormListScreen';
import FormBuilderScreen from './screens/FormBuilderScreen';
import ReportViewerScreen from './screens/ReportViewerScreen';
import RemindersScreen from './screens/RemindersScreen';
import ScheduledReportsScreen from './screens/ScheduledReportsScreen';
import CatalogScreen from './screens/CatalogScreen';
import AppearanceScreen from './screens/AppearanceScreen';
import NotFoundScreen from './screens/NotFoundScreen';
import TransformsScreen from './screens/TransformsScreen';
import CodeGeneratorScreen from './screens/CodeGeneratorScreen';
import PrintCodesScreen from './screens/PrintCodesScreen';
import AuditLogScreen from './screens/AuditLogScreen';

function RouterContainer() {
  const history = useRef(createBrowserHistory());

  useEffect(() => {
    return history.current.listen(location => pageView(location));
  }, []);

  return (
    <ReactRouter history={history.current}>
      <Router />
    </ReactRouter>
  );
}

function Router({signedIn, user, location}) {
  useEffect(() => {
    pageView(location);
  }, []);

  return (
    <Switch>
      <Route path="/privacy" component={PrivacyPolicyScreen} />
      <Route path="/forgotPassword" component={ForgotPasswordScreen} />
      <Route path="/resetPassword" component={ResetPasswordScreen} />
      {signedIn ? (
        <>
          <LabelWatcher />
          <NotificationWatcher />
          <Switch>
            <Route path="/" exact component={HomeScreen} />
            <Route path="/reports/schedules/:id?" component={ScheduledReportsScreen} />
            <Route path="/reports/:id" component={ReportViewerScreen} />
            <Route path="/reports" component={ReportScreen} />
            <Route path="/sheet/:templateId/:sheetIds" component={SheetScreen} />
            <Route path="/forms" exact component={FormListScreen} />
            <Route path="/forms/import/:importId" exact component={FormListScreen} />
            <Route path="/transforms" exact component={TransformsScreen} />
            <Route path="/codes" exact component={CodeGeneratorScreen} />
            <Route path="/codes/print" component={PrintCodesScreen} />
            { HasManagementRole(user) && <Route path="/users" component={UserScreen} /> }
            { HasManagementRole(user) && <Route path="/forms/create" exact component={FormBuilderScreen} /> }
            { HasManagementRole(user) && <Route path="/forms/create/:category/:file" component={FormBuilderScreen} /> }
            { HasManagementRole(user) && <Route path="/forms/:id" component={FormBuilderScreen} /> }
            { HasManagementRole(user) && <Route path="/reminders/:id?" component={RemindersScreen} /> }
            { HasManagementRole(user) && <Route path="/catalog" component={CatalogScreen} /> }
            { HasAdminRole(user) && <Route path="/admin/appearance" component={AppearanceScreen} /> }
            { HasAdminRole(user) && <Route path="/admin/auditlog" component={AuditLogScreen} /> }
            <Route path="*" component={NotFoundScreen} />
          </Switch>
        </>
      ) : (
        <Switch>
          <Route path="*" component={LoginScreen} />
        </Switch>
      )}
    </Switch>
  );
}

Router = withUser(withRouter(Router)); // eslint-disable-line

export default RouterContainer;
